export const Groups = {
  Initialization: 1000,
  Simulation: 2000,
  Presentation: 3000,
}
